<app-feed
  class="feed"
  [feed]="recentlyEditedDocuments | async"
  [noItemsOptions]="noItemsOptions"
  [trackByFn]="trackDocumentsByFn"
>
  <ng-template let-recentlyEditedDocument="feedItem">
    <app-recently-edited-list-item
      [recentlyEditedDocument]="recentlyEditedDocument"
      [trackingObject]="trackingObject"
      [trackingScreenName]="trackingScreenName"
      [featureToggles]="featureToggles"
      [enableRecurring]="enableRecurring"
    >
    </app-recently-edited-list-item>
  </ng-template>
</app-feed>
